// extracted by mini-css-extract-plugin
module.exports = {"s1eeudi8":"s1eeudi8"};